export default __webpack_public_path__ + "static/media/loginSvgPomelo.4ef52b27.svg";